export default "__VITE_ASSET__DDUhTouV__"